/**
 * attention 1:
 *  the data-id in select should be same with the main filter
 */

import filterState from "../Filter/filterState";
import "./index.css";
import fetchCardsHelper from "./fetchCardsHelper";
import { FILTER_ID_PLP_TOP } from "@src/utils/constant";
import {
  getFilterParamsByUrl,
  hasFilterUrlParams,
  hasOnlyOptionFilterUrlParams,
} from "../Filter";
import {
  pushSelectItemEventFromId,
  pushViewItemListEventFromHtml,
} from "./analytics";

interface ISelectDataSet extends DOMStringMap {
  eventId: string; // the id of the filter
  eventPayload: string;
}

export function setupSearchCards() {
  const container = document.querySelector(".container-search-cards");

  if (container == null) {
    return;
  }

  // the content will be updated when the page is loaded with filter params (not only option filter), need to prevent repetitive behavior.
  const filterParams = getFilterParamsByUrl();
  if (
    !hasFilterUrlParams(filterParams) ||
    hasOnlyOptionFilterUrlParams(filterParams)
  ) {
    // GTM push `view_item_list` event when first load list
    const html =
      container.querySelector(".container-search-cards-content")?.innerHTML ||
      "";
    pushViewItemListEventFromHtml(html);

    // insert load more button if needed
    fetchCardsHelper.insertLoad();
  }

  // change the sort select
  container
    .querySelector<HTMLSelectElement>("#sortPLP")
    ?.addEventListener("change", function (this: HTMLSelectElement) {
      const { eventId } = this.dataset as ISelectDataSet;
      filterState.updateSort({ id: eventId, value: this.value });
      const arg = filterState.getApiFilterAndSort(FILTER_ID_PLP_TOP);
      fetchCardsHelper.clearRequest();
      fetchCardsHelper.loadMore(arg);
    });

  // click the load more button
  container
    .querySelector<HTMLDivElement>(".container-search-cards-content")
    ?.addEventListener("click", function (e: Event) {
      const source = e.target as HTMLElement;
      if (source && source.id === "search-cards-load-more") {
        fetchCardsHelper.loadMore(
          filterState.getApiFilterAndSort(FILTER_ID_PLP_TOP)
        );
      }
    });

  // GTM push `select_item` event
  container.addEventListener("click", function (e) {
    const source = e.target as HTMLElement;
    if (
      source &&
      (source.classList.contains("container-search-cards-community-link") ||
        source.classList.contains("container-search-cards-unit-detail"))
    ) {
      const propertyId = source
        .closest(".container-search-cards-community")
        ?.getAttribute("data-property-id");
      pushSelectItemEventFromId(propertyId || "");
    }
  });
}
